"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _common = require("react-color/lib/components/common");
var _HBColorPicker = require("./HBColorPicker.styles");
var ColorCircleBlock = function ColorCircleBlock(_ref) {
  var color = _ref.color,
    alpha = _ref.alpha,
    onClick = _ref.onClick,
    isSelected = _ref.isSelected,
    _ref$isSquare = _ref.isSquare,
    isSquare = _ref$isSquare === void 0 ? false : _ref$isSquare,
    testId = _ref.testId;
  var ColorSwatch = /*#__PURE__*/_react["default"].createElement(_HBColorPicker.ColorCircle, {
    isSquare: isSquare,
    backgroundColor: color,
    onClick: onClick,
    "data-testid": testId
  }, alpha < 1 && alpha !== 0 && /*#__PURE__*/_react["default"].createElement(_common.Checkboard, null), alpha === 0 && /*#__PURE__*/_react["default"].createElement(_HBColorPicker.EmptyColorCircle, null));
  if (isSquare) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, ColorSwatch);
  }
  return /*#__PURE__*/_react["default"].createElement(_HBColorPicker.SelectedColorCircle, {
    isSelected: isSelected
  }, ColorSwatch);
};
var _default = exports["default"] = ColorCircleBlock;
//# sourceMappingURL=ColorCircleBlock.js.map